/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { http_VisitResponse } from '../models/http_VisitResponse';
import type { http_VisitStatsResponse } from '../models/http_VisitStatsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class VisitTrackingService {
    /**
     * Get Visits
     * Retrieve all visits for a given short ID with details including IP, country, GPS coordinates, and timestamp.
     * @param shortId The short ID to get visits for
     * @returns http_VisitResponse List of visits with total count
     * @throws ApiError
     */
    public static getVisits(
        shortId: string,
    ): CancelablePromise<http_VisitResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/visits/{short_id}',
            path: {
                'short_id': shortId,
            },
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Visit Statistics
     * Retrieve visit statistics including total count for a given short ID.
     * @param shortId The short ID to get statistics for
     * @returns http_VisitStatsResponse Visit statistics
     * @throws ApiError
     */
    public static getVisitsStats(
        shortId: string,
    ): CancelablePromise<http_VisitStatsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/visits/{short_id}/stats',
            path: {
                'short_id': shortId,
            },
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
}
